// Watches ALL URL changes: pushState, replaceState, popstate, hashchange, BFCache restores
export const onUrlChange = (cb: (url: string) => void) => {
    if (typeof window === "undefined") return () => { }; // Safe for SSR

    let last = "";

    const fire = () => {
        const href = location.href;
        if (href !== last) {
            last = href;
            cb(href);
        }
    };

    // Hook pushState / replaceState for SPA routing
    const _push = history.pushState;
    const _replace = history.replaceState;

    history.pushState = (...args) => {
        const ret = _push.apply(history, args as any);
        fire();
        return ret;
    };

    history.replaceState = (...args) => {
        const ret = _replace.apply(history, args as any);
        fire();
        return ret;
    };

    // Back/forward navigation
    const onPop = () => fire();
    addEventListener("popstate", onPop);

    // Hash routing
    const onHash = () => fire();
    addEventListener("hashchange", onHash);

    // BFCache restores
    const onPageShow = (e: PageTransitionEvent) => {
        if ((e as any).persisted) fire();
    };
    addEventListener("pageshow", onPageShow);

    // Initial capture
    fire();

    // Unsubscribe + restore original methods
    return () => {
        removeEventListener("popstate", onPop);
        removeEventListener("hashchange", onHash);
        removeEventListener("pageshow", onPageShow);
        history.pushState = _push;
        history.replaceState = _replace;
    };
};
